module.exports = __webpack_public_path__ + "static/p05_pollito03-702fab4dae166e96c2bf4a03a2c858f6.png";